import React from 'react';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import AdminLayout from '../../layouts/AdminLayout';
import WebNotificationFormModal from './WebNotificationFormModal';

export default function WebNotificationFormPage() {
  const history = useHistory();
  const location = useLocation();
  const { id } = useParams();
  const prefill = location.state?.prefill || null;

  const handleClose = () => {
    history.push('/notifications?tab=web');
  };

  const handleSuccess = () => {
    history.push('/notifications?tab=web');
  };

  return (
    <AdminLayout title={id ? 'Edit Web Notification' : 'Store Web Notification'}>
      <WebNotificationFormModal
        open={true}
        notificationId={id || null}
        prefillData={prefill}
        onClose={handleClose}
        onSuccess={handleSuccess}
      />
    </AdminLayout>
  );
}
